import React from 'react';

interface IProps {
    header: any;
    children: any;
    contentClassName?: string;
    headerClassName?: string;
    sectionClassName?: string;
}

const PageSectionLayout = ({ header, children, contentClassName, headerClassName, sectionClassName }: IProps) => (
    <section className={`main__layout_section flex flex-col global-background-color flex-1 rounded-tr-xl ${sectionClassName || ''}`}>
        <div className={`${headerClassName} xxl:px-4 px-3 pt-4 bg-inherit sticky top-0 z-[6] `}>{header}</div>
        <div className={`page-content-spacing flex-grow w-full flex flex-col content-baseline xxl:gap-4 gap-3 bg-inherit ${contentClassName} `}>{children}</div>
    </section>
);

export default PageSectionLayout;
